import React from 'react';

const MaintenancePage = ({ message }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      minHeight: '100vh',
      paddingBottom: '1.5rem',
      background: '#fff',
    }}
  >
    <div style={{ position: 'relative', width: '7rem', height: '7rem' }}>
      <img
        src={`${process.env.PUBLIC_URL}/new_maintenance_fdc_logo.svg`}
        alt="fdc-logo-maintenance"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
    <div style={{ position: 'relative', width: '100%', height: '50vh' }}>
      <img
        src={`${process.env.PUBLIC_URL}/new_maintenance_image.svg`}
        alt="image-maintenance"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
    <div>
      <p
        style={{
          textAlign: 'center',
          fontSize: '1.25rem',
          color: '#000',
          padding: '0 3rem 0.5rem',
          fontWeight: 700,
          margin: 0,
        }}
      >
        Website sedang dalam perbaikan
      </p>
      {message ? (
        <p
          style={{
            textAlign: 'center',
            fontSize: '1.125rem',
            padding: '0 3rem',
            fontWeight: 400,
            margin: 0,
          }}
        >
          {message}
        </p>
      ) : (
        <p
          style={{
            textAlign: 'center',
            fontSize: '1.125rem',
            padding: '0 3rem',
            fontWeight: 700,
            margin: 0,
          }}
        >
          Halaman sedang dalam perbaikan. Silahkan kembali beberapa saat lagi
        </p>
      )}
    </div>
  </div>
);

export default MaintenancePage;
